import {
  Sheet,
  SheetTitle,
  SheetFooter,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTrigger,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { AutocompleteUser } from 'src/components/AutocompleteUser';
import { useState } from 'react';
import { Customer, User } from 'src/trpc';
import { LucidePencil } from 'lucide-react';

export const InvoiceSelectCustomerSheet = ({
  user,
  isLoading,
  onChangeCustomer,
}: {
  user?: User;
  isLoading?: boolean;
  onChangeCustomer: (customerId: string) => void;
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleCustomerChange = (customer: Customer) => {
    setOpen(false);
    onChangeCustomer(customer._id!);
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          size="icon"
          className="absolute top-0 right-0"
          variant="ghost"
          onClick={() => setOpen(true)}
        >
          <LucidePencil className="w-4 h-4" />
        </Button>
      </SheetTrigger>
      <SheetContent className="p-0 sm:max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] h-full flex flex-col justify-between">
        <div className="grid h-full grid-rows-[auto_1fr_auto]">
          <SheetHeader className="border-b bg-white px-6 py-4">
            <SheetTitle className="text-left text-lg font-semibold text-gray-900">
              Change Customer
            </SheetTitle>
          </SheetHeader>

          <div className="relative min-w-[400px] w-full flex flex-col gap-2 overflow-y-auto">
            <AutocompleteUser
              userId={user?._id}
              setCustomer={handleCustomerChange}
              isLoading={isLoading}
              className="w-full"
            />
            {isLoading && <p className="text-xs text-muted">Updating invoice customer...</p>}
          </div>

          <SheetFooter className="border-t bg-gray-50 px-6 py-4">
            <div className="flex w-full justify-end gap-4">
              <SheetClose asChild>
                <Button variant="outline" size="sm" onClick={() => setOpen(false)}>
                  Cancel
                </Button>
              </SheetClose>
            </div>
          </SheetFooter>
        </div>
      </SheetContent>
    </Sheet>
  );
};
